import {BrowserModule} from '@angular/platform-browser';
import {ChangeDetectorRef, LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

// components
import {
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,

    /** FORMS **/
        MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule, MatPaginatorIntl, MatProgressBarModule, MatCardModule, MatGridListModule, MatSnackBar, MatSnackBarModule,
    MatDialogModule, MatSortModule, DateAdapter
} from '@angular/material';
/***    ANGULAR MATERIAL IMPORT    ***/

import {AppComponent} from './AppModule/AppComponent/app.component';
import {NavComponent} from './AppModule/NavComponent/nav.component';
import {LoginComponent} from './AppModule/LoginComponent/login.component';

import {UsersModule} from './UsersModule/users.module';
import {DashboardModule} from './DashboardModule/dashboard.module';

import {HttpClientModule} from '@angular/common/http';
import {CzechPaginatorIntl} from './model/Providers/CzechPaginatorIntl';

import {LoginRouterModule} from './routers/login-router.module';
import {AppRouterModule} from './routers/app-router.module';
import {UserService} from './services/user.service';
import {AuthGuard} from './model/Guards/auth.guard';
import {ProgressService} from './services/progress.service';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SnackService} from './services/snack.service';
import {DialogService} from './services/dialog.service';
import {PipesModule} from './pipes/pipes.module';
import {CustomersModule} from './CustomersModule/customers.module';
import {ProductsModule} from './ProductsModule/products.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorageService} from './services/local-storage.service';
import {ContractsModule} from './ContractsModule/contracts.module';
import {BarcodeService} from './services/barcode.service';
import {VatRateService} from './services/vat-rate.service';

/*** LOCALE DATA ***/
import {registerLocaleData} from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import localeCsExtra from '@angular/common/locales/extra/cs';
import {PrintService} from './services/print.service';
import {MailService} from './services/mail.service';
import {ConfigService} from './services/config.service';
import {AdminGuard} from './model/Guards/admin.guard';
import {RoleDirective} from './directives/role.directive';
import {CzDateAdapter} from './model/Adapters/CzDateAdapter';
import { RevenueModule } from './RevenueModule/revenue.module';
import {TransportModule} from './TransportModule/transport.module';
import {DocumentsModule} from './DocumentsModule/documents.module';

registerLocaleData(localeCs, localeCsExtra);


@NgModule({
    declarations: [
        AppComponent,
        NavComponent,
        LoginComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,

        NgbModule.forRoot(),

        // Angular Material animations
        BrowserAnimationsModule,

        // Angular Material components
        MatDialogModule,
        MatSidenavModule,
        MatToolbarModule,
        MatListModule,
        MatIconModule,
        MatProgressBarModule,
        MatButtonModule,
        MatMenuModule,
        MatCardModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSnackBarModule,
        ReactiveFormsModule,

        FormsModule,

        FlexLayoutModule,

        UsersModule,
        ProductsModule,
        CustomersModule,
        DashboardModule,
        ContractsModule,
        DocumentsModule,
        RevenueModule,
        TransportModule,

        LoginRouterModule,
        AppRouterModule,

        PipesModule,
    ],
    providers: [
        ConfigService,
        ProgressService,
        AuthGuard,
        AdminGuard,
        SnackService,
        DialogService,
        VatRateService,
        BarcodeService,
        PrintService,
        MailService,
        {provide: DateAdapter, useClass: CzDateAdapter},
        {provide: LOCALE_ID, useValue: 'cs-CZ'},
        {provide: MatPaginatorIntl, useClass: CzechPaginatorIntl},
        LocalStorageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /app/src/app.main.ts